import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'

@Component({
  selector: 'app-progress-cell',
  templateUrl: './progress-cell.component.html',
  styleUrls: ['./progress-cell.component.scss'],
})
export class ProgressCellComponent implements OnChanges {
  @Input() value: number | string = 0

  percent = 0
  displayText = '0%'

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.updateProgress()
    }
  }

  private updateProgress(): void {
    const rawValue = this.value

    // Normalize percent as a number
    this.percent =
      typeof rawValue === 'number'
        ? rawValue
        : parseInt((rawValue as string).replace('%', ''), 10) || 0

    // Format text with a percent sign
    this.displayText = this.percent + '%'
  }
}
